import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, userinfoActions } from '../../../store/actions'

const InactiveBox = (props) => {
  useEffect(() => {
    if (props.isInactive) {
      let text = props.isType == 'N' ? '폐쇄' : '활성화'
      props.onChange()

      props.success({
        title: '전자지갑' + text + '설정',
        message: '전자지갑이 ' + text + '되었습니다.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            window.location.reload()
          },
        },
      })
    }
  }, [props.isInactive])

  const updateInactive = (e) => {
    e.preventDefault()

    // 사용자 휴면설정 호출
    props.updateInactive({ acntYn: props.isType == 'N' ? 'Y' : 'N', passwd: props.passwd })
  }

  // 팝업 style
  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '0.6',
    zIndex: '997',
  }
  let styleModal = {
    position: 'absolute',
    display: 'block',
    opacity: '1',
    zIndex: '998',
  }

  if (!props.isView) {
    return null
  } else {
    return (
      <React.Fragment>
        <div style={style}></div>
        <div id="invt-info" className="modal w450" style={styleModal}>
          <div className="modal-head">
            <h2>전자지갑 {props.isType == 'N' ? '폐쇄' : '활성화'}</h2>
          </div>
          <div className="modal-cont">
            <div>전자지갑을 {props.isType == 'N' ? '폐쇄' : '활성화'}하시겠습니까?</div>
            <div className="btn-block" style={{ textAlign: 'right' }}>
              <button href="#" className="btn-secondary md b-close" onClick={props.onChange}>
                취소
              </button>
              <button href="#" className="btn-primary md b-close" onClick={updateInactive}>
                확인
              </button>
            </div>
          </div>
          <button
            onClick={() => {
              props.onChange(false)
            }}
            type="button"
            className="modal-close b-close"
          >
            창닫기
          </button>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isInactive: state.userinfo?.isInactive,
  }
}

const actionCreators = {
  load: userinfoActions.load,
  updateInactive: userinfoActions.updateInactive,
  success: alertActions.success,
}

export default connect(mapStateToProps, actionCreators)(InactiveBox)
